<template>
  <div class="form-quizz-questions-component">
    <div class="mb-5">
      <step-title
        title="Questões"
        description="Determine as questões e as respostas da sua avaliação"
        icon="fa-solid fa-file-pen"
      />
    </div>

    <draggable v-model="sortedQuestions" handle=".handle" group="questions">
      <form-quizz-question-item
        v-for="(question, i) in sortedQuestions"
        :key="`q-${i}`"
        :item="question"
        :form="form"
        :is-final-quiz="isFinalQuiz"
        :is-all-saved="is_all_saved"
        @delete="submitDeleteQuestion"
        @remove="remove"
        @update="refresh"
        :index="i"
      />
    </draggable>

    <div class="mb-3"></div>

    <div
      v-if="!sortedQuestions.length"
      class="container centralize-row text-center pt-5 mb-6"
    >
      <div class="row justify-content-center py-9">
        <div class="col-lg-5">
          <img
            class="d-block mb-5 mx-auto"
            src="@/assets/images/home/welcome.svg"
          />
          <h5>Você ainda não cadastrou nenhuma pergunta</h5>
          <small class="text-secondary mb-5">
            Clique no botão abaixo para cadastrar
          </small>
        </div>
      </div>
    </div>

    <button-add-question @click="add" text="Adicionar questão" />

    <div class="d-flex align-items-center justify-content-between mt-9">
      <button class="btn btn-outline-secondary px-6" @click="$emit('previous')">
        <i class="icon-angle-left mr-5"></i> Voltar
      </button>
      <button class="btn btn-primary px-6" type="button" @click="saveSubmit">
        <b-spinner v-if="loading" small variant="light" />
        <span v-else>Salvar</span>
      </button>
    </div>
  </div>
</template>

<script>
import ButtonAddQuestion from "@/components/ButtonAddQuestion";
import draggable from "vuedraggable";
import FormQuizzQuestionItem from "./FormQuizzQuestionItem";

export default {
  components: { draggable, FormQuizzQuestionItem, ButtonAddQuestion },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    },
    isFinalQuiz: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "form",
    event: "change"
  },
  data() {
    return {
      questions: []
    };
  },
  computed: {
    is_all_saved() {
      return this.form.questions.reduce((ac, cur) => ac && !!cur.id, true);
    },
    sortedQuestions: {
      get() {
        return [...this.form.questions]
          .filter(q => !q.deleted)
          .sort((a, b) => a.sort - b.sort);
      },
      set(value) {
        for (let i in this.form.questions) {
          for (let j in value) {
            if (this.form.questions[i].id === value[j].id) {
              this.form.questions[i].sort = j;
            }
          }
        }
        this.saveOrder();
      }
    },
    is_all_question_with_alternatives() {
      return [...this.form.questions].reduce(
        (ac, cur) => ac && cur.answer_options && cur.answer_options.length > 0,
        true
      );
    }
  },
  methods: {
    refresh() {
      this.$emit("update");
    },
    async saveOrder() {
      const error_index = undefined;
      try {
        const action =
          this.$route.name == "product-members-module-quizz-final-edit"
            ? "membersQuizz/putFinal"
            : "membersQuizz/put";

        await this.$store.dispatch(action, this.form);
      } catch (e) {
        error_index = i;
      }

      if (error_index) {
        this.$message.error(
          `Não foi possível salvar a pergunta ${error_index + 1}`
        );

        return;
      }

      this.refresh();
    },
    success(response) {
      this.form.questions = response.data.results;
    },
    add() {
      this.form.questions = [
        ...this.form.questions,
        {
          title: "",
          answer_options: []
        }
      ];
    },
    remove(index) {
      this.form.questions = this.form.questions.filter((_, i) => i !== index);
    },
    submitDeleteQuestion(index) {
      const form = { ...this.form };

      const nonDeleted = form.questions.filter(q => !q.deleted);

      nonDeleted[index].deleted = true;

      const index_to_change_in_root_array = form.questions.findIndex(
        q => q.title == nonDeleted[index].title
      );

      form.questions[index_to_change_in_root_array] = nonDeleted[index];

      this.$emit("change", { ...form });
    },
    saveSubmit() {
      const nonDeleted = this.form.questions.filter(q => !q.deleted);

      if (this.form?.title?.length > 64) {
        this.$message.error(
          "O nome da avaliação não deve ter mais que 64 caracteres"
        );
        return;
      }

      if (!this.form.questions || nonDeleted.length == 0) {
        this.$message.warning(
          "Por favor, adicione questões á avaliação antes de salvar"
        );
        return;
      }

      if (!this.is_all_question_with_alternatives) {
        this.$message.warning(
          "Existem questões sem alternativas, por favor insira pelo menos 1 alternativa em cada questão."
        );
        return;
      }

      this.$emit("save");
    }
  }
};
</script>
<style lang="scss" scoped>
.form-quizz-questions-component {
  .btn {
    .icon-angle-left {
      font-size: 20px;
    }
  }

  ::v-deep .fa-solid.fa-file-pen {
    font-size: 16px;
    margin-right: -8px;
  }
}
</style>
